import { render, staticRenderFns } from "./LocalYellowWaveChallenge.vue?vue&type=template&id=3ba9f260&scoped=true"
import script from "./LocalYellowWaveChallenge.vue?vue&type=script&lang=js"
export * from "./LocalYellowWaveChallenge.vue?vue&type=script&lang=js"
import style0 from "./LocalYellowWaveChallenge.vue?vue&type=style&index=0&id=3ba9f260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba9f260",
  null
  
)

export default component.exports